export default function serviceWorker() {
  if ('serviceWorker' in navigator) {
    if (!window.location.pathname.startsWith('/irvo-vendor-checkin-sfa')) {
      navigator.serviceWorker
        .register('/service-worker.js', { scope: '/' })
        .then((_) => console.log('Service worker registered!'))
        .catch((err) => console.log('Service worker registration failed!', err));
    } else {
      console.log('Skipping service worker for SFA route');
      navigator.serviceWorker.getRegistrations().then((registrations) => {
        registrations.forEach((registration) => registration.unregister());
      });
    }
  }
}
